module.exports = __webpack_public_path__ + "static/media/linkedin.46cad43f.svg";